/*
 * Module for the SPC Estimate page
*/
rs.module("ui/content/benefits/estimates/spcestimate",

    [
        "common/select-helper",
        "controls/components/event-banner",
    ],

    function (selectHelper, eventBanner) {
        // Initialize the module
        function initialize(jsSelectors, spcTypes, backendUrls) {

            // Unpack Js Selectors
            var fundPicker = $.js(jsSelectors.fundPicker, { required: false });
            var fundKey = $.js(jsSelectors.fundKey);
            var accountKey = $.js(jsSelectors.accountKey);
            var spcEstimateForm = $.js(jsSelectors.spcEstimateForm);
            var spcTypeSelect = spcEstimateForm.js(jsSelectors.spcTypeSelect);
            var separationDate = spcEstimateForm.js(jsSelectors.separationDate);
            var permissiveDetailsSection = spcEstimateForm.js(jsSelectors.permissiveDetailsSection);
            var militaryServiceMonths = spcEstimateForm.js(jsSelectors.militaryServiceMonths);
            var militaryDetailsSection = spcEstimateForm.js(jsSelectors.militaryDetailsSection);
            var spcTypeExplanations = spcEstimateForm.js(jsSelectors.spcTypeExplanations);
            var generateButton = spcEstimateForm.js(jsSelectors.generateButton, { required: false });
            var generateButtonLabel = spcEstimateForm.js(jsSelectors.generateButtonLabel, { required: false });
            var generateSpinner = spcEstimateForm.js(jsSelectors.generateSpinner, { required: false });
            var submitButton = spcEstimateForm.js(jsSelectors.submitButton, { required: false });
            var submitSpinner = spcEstimateForm.js(jsSelectors.submitSpinner, { required: false });
            var militaryOptions = $.js(jsSelectors.militaryOptions, { required: false });
            var permissiveOptions = $.js(jsSelectors.permissiveOptions, { required: false });

            // The fields available on the form depend on which spc type is selected
            spcTypeSelect.change(function () {
                eventBanner.removeAllMessages();

                permissiveDetailsSection.toggle($(this).val() == spcTypes.permissive);
                militaryDetailsSection.toggle($(this).val() == spcTypes.military);
                spcTypeExplanations.toggle($(this).val() == '');

                changeGenerateButtonName($(this).val() == spcTypes.permissive)

                setMilitaryMode($(this).val() == spcTypes.military)
                setPermissiveMode($(this).val() == spcTypes.permissive)
                setNoTypeMode($(this).val() == '')
            });

            // On the rare occasion the user has more than one relevant fund, we'll start the process over if they change funds
            fundPicker.change(function() {
                window.location.href = `${backendUrls.servicePurchaseEstimate}?fundKey=${fundPicker.val()}`;
            });

            militaryServiceMonths.change(function () {
                eventBanner.removeAllMessages();
                setMilitaryMode(true);
                generateButton.setDisabled(!$(this).val());
            });

            separationDate.change(function () {
                eventBanner.removeAllMessages();
                setPermissiveMode(true);
                generateButton.setDisabled(!$(this).val());
            });

            generateButton.click(function () {
                eventBanner.removeAllMessages();

                var spcMode = spcTypeSelect.val();
                generateSpinner.show();
                
                if (spcMode == spcTypes.military)
                {
                    militaryOptions.hide();
                    $.get(
                        backendUrls.servicePurchaseEstimateOptions,
                        {
                            accountKey: accountKey.val(),
                            fundKey: fundKey.val(),
                            spctype: spcTypes.military,
                            separationdate: null,
                            militaryservicemonths: militaryServiceMonths.val()
                        })
                        .done(function (html) {
                            militaryOptions.html(html);
                            militaryOptions.show();
                            hideSubmitShowGenerate(false);
                        })
                        .always(function () {
                            generateSpinner.hide();
                        });
                }
                else if (spcMode == spcTypes.permissive)
                {
                    permissiveOptions.hide();
                    $.get(
                        backendUrls.servicePurchaseEstimateOptions,
                        {
                            accountKey: accountKey.val(),
                            fundKey: fundKey.val(),
                            spctype: spcTypes.permissive,
                            separationdate: separationDate.val() ? new Date(separationDate.val()).toISODateString() : null,
                            militaryservicemonths: null
                        })
                        .done(function (html) {
                            permissiveOptions.html(html);
                            permissiveOptions.show();
                            hideSubmitShowGenerate(false);
                        })
                        .always(function () {
                            generateSpinner.hide();
                        });
                }
            });

            // Show a loading spinner and "disable" fields when we submit
            spcEstimateForm.submit(function(e) {

                // Clear event banner messages
                eventBanner.removeAllMessages();

                // Validate form before showing spinner and hiding fields
                var validator = $(this).validate();
                var isValid = validator.form();

                if (isValid) {
                    submitSpinner.show();

                    // Prevent further interaction with the form
                    spcEstimateForm.css("pointer-events", "none");
                    // Bootstrap's custom control toggles don't respond to pointer events, so manually unhook them
                    spcEstimateForm.find(".custom-control-label").removeAttr("for");
                }
                else {
                    e.preventDefault();
                }
            });

            // Hides the submit button and shows the generate button if true, reverse if false
            function hideSubmitShowGenerate(hideSubmit) {
                if (hideSubmit) {
                    generateButton.setDisabled(true);
                    submitButton.setDisabled(true);
                    submitButton.hide();
                    generateButton.show();
                }
                else {
                    submitButton.setDisabled(false);
                    submitButton.show();
                    generateButton.hide();
                }
            }

            // Clear/hide permissive fields, show and disable generate button
            function setMilitaryMode(clear) {
                if (clear) {
                    separationDate.val('');
                    permissiveOptions.hide();
                    hideSubmitShowGenerate(true);
                }
            }

            // Clear/hide military fields, disable generate
            function setPermissiveMode(clear) {
                if (clear) {
                    militaryServiceMonths.val('');
                    militaryOptions.hide();
                    hideSubmitShowGenerate(true);
                }
            }

            // Clear all forms and hide spc sections
            function setNoTypeMode(clear) {
                if (clear) {
                    setMilitaryMode(clear);
                    setPermissiveMode(clear);
                }
            }

            // Change generate button name based on SPC Type
            function changeGenerateButtonName(change) {
                if (change) {
                    generateButtonLabel.text('Calculate Cost Options');
                }
                else {
                    generateButtonLabel.text('Generate');
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);
